import gql from 'graphql-tag';

export const GET_CLOF_BASED_KEY_METRICS = gql`
  query getClofBasedKeyMetrics(
    $params: ReportInput!
    $attributionParams: AttributionInput!
  ) {
    clofBasedKeyMetrics(params: $params) {
      result {
        onlineNumberTransactions
        onlineSalesAmount
        totalNumberTransactions
        totalSalesAmount
        totalAov
        periodStart
        periodEnd
      }
      timeslice
    }

    purchasesBySubWithMulPurchasesBySegment(params: $params) {
      totalPurchases
      percentOfMerchantTotal
      cashbackPercentage
    }

    attributionByMerchant(params: $attributionParams) {
      result {
        merchantName
        eventDate
        sevenDays {
          attributedRate
          appClickAttributedRate
          emailOpenAttributedRate
          appImpressionAttributedRate
          pushNotificationAttributedRate
          socialAttributionRate
        }
        fourteenDays {
          attributedRate
          appClickAttributedRate
          emailOpenAttributedRate
          appImpressionAttributedRate
          pushNotificationAttributedRate
          socialAttributionRate
        }
        thirtyDays {
          attributedRate
          appClickAttributedRate
          emailOpenAttributedRate
          appImpressionAttributedRate
          pushNotificationAttributedRate
          socialAttributionRate
        }
      }
      timeslice
      averageRates {
        sevenDays
        thirtyDays
        fourteenDays
      }
    }
  }
`;

export default GET_CLOF_BASED_KEY_METRICS;
